import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export default function CheckoutSteps(props) {
  return (
    <Row className="checkout-steps">
      <Col className={props.step1 ? 'active' : ''}>Sign-In</Col>
      <Col className={props.step2 ? 'active' : ''}> Customer-Info</Col>
      <Col className={props.step3 ? 'active' : ''}> Add Products</Col>
      <Col className={props.step4 ? 'active' : ''}> Cart</Col>
      <Col className={props.step5 ? 'active' : ''}> Preview Order</Col>
      <Col className={props.step6 ? 'active' : ''}> Place Order</Col>
    </Row>
  );
}
